import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routes = [
    {
        path: '/about',
        name: 'about',
        component: () => import ('@/views/about/index'),
        meta: { title: '关于我们' },
    },
    {
        path: '/en/about',
        name: 'enabout',
        component: () => import ('@/views/about/en'),
        meta: { title: 'About Us' },
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import ('@/views/privacy/index'),
        meta: { title: '隐私政策' },
    },
    {
        path: '/en/privacy',
        name: 'privacy',
        component: () => import ('@/views/privacy/en'),
        meta: { title: 'Privacy' },
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: () => import ('@/views/agreement/index'),
        meta: { title: '用户协议' },
    },
    {
        path: '/en/agreement',
        name: 'enagreement',
        component: () => import ('@/views/agreement/en'),
        meta: { title: 'Agreement' },
    },
    {
        path: '/problem/cn/:id',
        name: 'problem',
        component: () => import ('@/views/problem/index'),
        meta: { title: '支付问题' },
    },
]

const router = new Router({
    mode: "hash",
    routes,
    linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        window.location.reload();
    }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js